import React, { useState } from "react";
import { useMasterData } from "../context/MasterDataContext";
import "../Styles/ProfileSearch.css";

const AGES = Array.from({ length: 43 }, (_, i) => i + 18); // 18 - 60

export const DEFAULT_SEARCH = {
  lookingFor: "Woman",
  ageFrom: 22,
  ageTo: 27,
  religionId: "",
  languageId: "",
};

export default function ProfileSearchForm({
  initial = DEFAULT_SEARCH,
  onSubmit,
  compact = false,
}) {
  const { religionMasterData = [], languageMasterData = [] } = useMasterData();
  const [form, setForm] = useState({ ...DEFAULT_SEARCH, ...initial });

  const set = (key) => (e) => {
    const value = e.target.value;
    setForm((prev) => {
      const next = { ...prev, [key]: value };
      // keep the age range valid
      if (key === "ageFrom" && Number(value) > Number(prev.ageTo)) {
        next.ageTo = value;
      }
      if (key === "ageTo" && Number(value) < Number(prev.ageFrom)) {
        next.ageFrom = value;
      }
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form
      className={`ps-form ${compact ? "ps-form-compact" : ""}`}
      onSubmit={handleSubmit}
    >
      <label className="ps-field">
        <span>I'm looking for a</span>
        <select value={form.lookingFor} onChange={set("lookingFor")}>
          <option value="Woman">Woman</option>
          <option value="Man">Man</option>
        </select>
      </label>

      <div className="ps-field ps-age">
        <span>aged</span>
        <div className="ps-age-row">
          <select
            aria-label="Age from"
            value={form.ageFrom}
            onChange={set("ageFrom")}
          >
            {AGES.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
          <em>to</em>
          <select
            aria-label="Age to"
            value={form.ageTo}
            onChange={set("ageTo")}
          >
            {AGES.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
        </div>
      </div>

      <label className="ps-field">
        <span> religion</span>
        <select value={form.religionId} onChange={set("religionId")}>
          <option value="">Any</option>
          {religionMasterData.map((r) => (
            <option key={r.ReligionId} value={r.ReligionId}>
              {r.ReligionName}
            </option>
          ))}
        </select>
      </label>

      <label className="ps-field">
        <span>mother tongue</span>
        <select value={form.languageId} onChange={set("languageId")}>
          <option value="">Any</option>
          {languageMasterData.map((l) => (
            <option key={l.LangId} value={l.LangId}>
              {l.LangDesc}
            </option>
          ))}
        </select>
      </label>

      <button type="submit" className="ps-submit">
        Search Profile
      </button>
    </form>
  );
}
